import { useState, useEffect, useCallback } from 'react';
import { fetchNewsPosts } from '../services/newsService';
import type { NewsPost } from '../types/news';

const PAGE_SIZE = 20;

export function useNews() {
  const [posts, setPosts] = useState<NewsPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    const { data, error: err, hasMore: more } = await fetchNewsPosts(0, PAGE_SIZE);
    if (err) {
      setError(err.message);
      setPosts([]);
      setHasMore(false);
    } else {
      setPosts(data);
      setHasMore(more);
    }
    setLoading(false);
  }, []);

  const loadMore = useCallback(async () => {
    if (loadingMore || !hasMore) return;

    setLoadingMore(true);
    const { data, error: err, hasMore: more } = await fetchNewsPosts(posts.length, PAGE_SIZE);
    if (err) {
      setError(err.message);
    } else {
      setPosts((prev) => [...prev, ...data]);
      setHasMore(more);
    }
    setLoadingMore(false);
  }, [posts.length, hasMore, loadingMore]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { posts, loading, loadingMore, error, hasMore, refresh, loadMore };
}
